const FormattedCurrency = (props) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: props.currency }).format(props.value);
};

export default FormattedCurrency;
